import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import Chat from '../components/Chat';
import { useAuth } from '../context/AuthContext';
import { IoChatbubblesSharp } from 'react-icons/io5';

const ChatPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4, height: 'calc(100vh - 150px)', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ mb: 3, flexShrink: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <IoChatbubblesSharp style={{ fontSize: '40px', color: '#1976d2' }} />
          <Box>
            <Typography variant="h4" component="h1" gutterBottom>
              Community Chat
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Connect with fellow TFIC members in real-time. Messages are synced with our Discord server.
            </Typography>
          </Box>
        </Box>

        <Paper sx={{ p: 2, bgcolor: 'info.main', color: 'info.contrastText', mb: 3 }}>
          <Typography variant="body2">
            <strong>💡 Tip:</strong> This chat is connected to our Discord #general channel. 
            You can chat here or join us on Discord for the full experience!
          </Typography>
        </Paper>
      </Box>

      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Chat 
          currentUserId={user?.id} 
          isAdmin={user?.role?.name === 'Admin' || user?.role?.name === 'Leadership'}
        />
      </Box>
    </Container>
  );
};

export default ChatPage;
